import classNames from 'classnames/bind';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { PrimaryButton } from '../../../components';
import useCalendly from '../../Calendly';
import styles from './OmossHero.module.scss';
import { getSiteUiFromPath } from '../../../lib/polylang';

let cx = classNames.bind(styles);

// Helper to get optimized image source for hero
// Use medium_large or large size to balance quality and performance
const getOptimizedImageSrc = (imageNode) => {
  if (!imageNode) return null;
  
  const sizes = imageNode.mediaDetails?.sizes || [];
  
  // For hero images, use large (1024px) or medium_large (768px) for faster loading
  // Next.js will optimize further based on device size
  const large = sizes.find(size => size.name === 'large');
  const mediumLarge = sizes.find(size => size.name === 'medium_large');
  
  // Prefer large (1024px) for good quality without huge file size
  return large?.sourceUrl || mediumLarge?.sourceUrl || imageNode.mediaItemUrl || imageNode.sourceUrl;
};

export default function OmossHero({ data }) {
  const router = useRouter();
  const ui = getSiteUiFromPath(router.asPath);

  if (!data) return null;

  const { openCalendlyInline } = useCalendly();

  return (
    <section className={cx('heroSection')}>
      <div className={cx('container')}>
        <div className={cx('content')}>
          {data.smallTopHeader && (
            <span className={cx('smallHeader')}>{data.smallTopHeader}</span>
          )}
          <h1>{data.mainHeaderText}</h1>
          <div className={cx('textButtonWrapper')}>
            {data.subText && (
              <p className={cx('subText')}>{data.subText}</p>
            )}
            <div className={cx('buttonWrapper')}>
              <PrimaryButton
                text={ui.bookFreeIntroMeeting}
                onClick={(e) => { 
                  e.preventDefault(); 
                  e.stopPropagation(); 
                  openCalendlyInline(e, 'https://calendly.com/sales-mediabooster/intromote-digital-markedsforing'); 
                }}
              />
            </div>
          </div>
        </div>
        {data.heroImage?.node && (
          <div className={cx('imageWrapper')}>
            <Image
              src={getOptimizedImageSrc(data.heroImage.node)}
              alt={data.heroImage.node.altText || ''}
              fill
              className={cx('image')}
              priority={true}
              quality={100}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 1200px"
              placeholder="blur"
              blurDataURL="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwMCIgaGVpZ2h0PSI1MDAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTIwMCIgaGVpZ2h0PSI1MDAiIGZpbGw9IiNlZWUiLz48L3N2Zz4="
              style={{
                objectFit: 'cover',
                objectPosition: 'center'
              }}
            />
          </div>
        )}
      </div>
    </section>
  );
} 